module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "bar-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.no_padding_code
    }
  }, [_c('Bar', [_vm._v("\n      I'm Bar.\n    ")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "use_padding",
      "description": "包含padding",
      "code": _vm.have_padding_code
    }
  }, [_c('Bar', {
    attrs: {
      "use_padding": true
    }
  }, [_c('Btn', [_vm._v("Button")]), _vm._v(" "), _c('Btn', [_vm._v("Button")]), _vm._v(" "), _c('Btn', [_vm._v("Button")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8b77022"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Bar.vue
// module id = 689
// module chunks = 0